"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardLayout = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2020 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_grid_system_1 = require("react-grid-system");
var DashboardLayoutSection_1 = require("./DashboardLayoutSection");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var constants_1 = require("./constants");
var layout_1 = require("./facade/layout");
var sizing_1 = require("./utils/sizing");
var isEqual_1 = tslib_1.__importDefault(require("lodash/isEqual"));
react_grid_system_1.setConfiguration(constants_1.DASHBOARD_LAYOUT_GRID_CONFIGURATION);
/**
 * DashboardLayout is customizable component for rendering {@link IDashboardLayout}.
 *
 * @alpha
 */
function DashboardLayout(props) {
    var layout = props.layout, _a = props.sectionKeyGetter, sectionKeyGetter = _a === void 0 ? function (_a) {
        var section = _a.section;
        return section.index();
    } : _a, sectionRenderer = props.sectionRenderer, sectionHeaderRenderer = props.sectionHeaderRenderer, itemKeyGetter = props.itemKeyGetter, itemRenderer = props.itemRenderer, widgetRenderer = props.widgetRenderer, gridRowRenderer = props.gridRowRenderer, className = props.className, debug = props.debug, onMouseLeave = props.onMouseLeave, enableCustomHeight = props.enableCustomHeight;
    var removeHeights = function (layout, enableCustomHeight) {
        if (enableCustomHeight) {
            return layout;
        }
        return sizing_1.getLayoutWithoutGridHeights(layout);
    };
    var _b = react_1.useMemo(function () {
        var updatedLayout = removeHeights(layout, enableCustomHeight);
        var layoutFacade = layout_1.DashboardLayoutFacade.for(sizing_1.unifyDashboardLayoutItemHeights(updatedLayout));
        var resizedItemPositions = sizing_1.getResizedItemPositions(layout, layoutFacade.raw());
        return { layoutFacade: layoutFacade, resizedItemPositions: resizedItemPositions };
    }, [layout, enableCustomHeight]), layoutFacade = _b.layoutFacade, resizedItemPositions = _b.resizedItemPositions;
    return (react_1.default.createElement("div", { className: classnames_1.default("gd-fluidlayout-container", "s-fluid-layout-container", "gd-dashboards", className), onMouseLeave: onMouseLeave },
        react_1.default.createElement(react_grid_system_1.ScreenClassProvider, { useOwnWidth: false },
            react_1.default.createElement(react_grid_system_1.ScreenClassRender, { render: function (screen) {
                    return screen ? (react_1.default.createElement(react_grid_system_1.Container, { fluid: true, className: "gd-fluidlayout-layout s-fluid-layout" }, layoutFacade.sections().map(function (section) {
                        return (react_1.default.createElement(DashboardLayoutSection_1.DashboardLayoutSection, { key: sectionKeyGetter({
                                section: section,
                                screen: screen,
                            }), section: section, sectionRenderer: function (renderProps) {
                                return sectionRenderer ? (sectionRenderer(tslib_1.__assign(tslib_1.__assign({}, renderProps), { debug: debug }))) : (react_1.default.createElement(renderProps.DefaultSectionRenderer, tslib_1.__assign({}, renderProps, { debug: debug })));
                            }, sectionHeaderRenderer: sectionHeaderRenderer, itemKeyGetter: itemKeyGetter, itemRenderer: itemRenderer, gridRowRenderer: gridRowRenderer, widgetRenderer: function (renderProps) {
                                var isResizedByLayoutSizingStrategy = resizedItemPositions.some(function (position) {
                                    return isEqual_1.default(position, [
                                        renderProps.item.section().index(),
                                        renderProps.item.index(),
                                    ]);
                                });
                                return widgetRenderer ? (widgetRenderer(tslib_1.__assign(tslib_1.__assign({}, renderProps), { isResizedByLayoutSizingStrategy: isResizedByLayoutSizingStrategy,
                                    debug: debug }))) : (react_1.default.createElement(renderProps.DefaultWidgetRenderer, tslib_1.__assign({}, renderProps, { debug: debug, isResizedByLayoutSizingStrategy: isResizedByLayoutSizingStrategy })));
                            }, screen: screen }));
                    }))) : null;
                } }))));
}
exports.DashboardLayout = DashboardLayout;
//# sourceMappingURL=DashboardLayout.js.map